/** Filters beyond the positional ones, for the I-9 listing. */
export interface ActiveI9ListFilters {
  /** Only rows the queue is prompting this action on (VTK-1950). */
  nextAction?: string;
  /**
   * Only employees whose reverification has no date to go by and needs review: a document valid for
   * the duration of status, or a missing or unreadable date (VTK-2041).
   */
  reverificationReview?: boolean;
  /** Only I-9s with a Supplement B started and not yet signed (VTK-2017). */
  supplementBPending?: boolean;
}

/**
 * The status filter's "Supplement B Pending" choice. Not an I-9 status: the I-9 keeps its own status
 * while a Supplement B is in progress, so this value is sent as its own flag rather than as `status`.
 */
export const SUPPLEMENT_B_PENDING_FILTER = 'supplementBPending';
